import { getOssConfig } from '@/api/system/upload'

let cachedSignature = null
let cachedExpireAt = 0
let inflightPromise = null

/** 签名缓存 1 小时，提前 5 分钟刷新 */
export async function getCachedOssSignature(forceRefresh = false) {
  const now = Date.now()
  if (!forceRefresh && cachedSignature && cachedExpireAt > now + 300000) {
    return cachedSignature
  }
  if (inflightPromise && !forceRefresh) {
    return inflightPromise
  }
  inflightPromise = getOssConfig()
    .then((res) => {
      const sig = res.data || res
      const expireSec = parseInt(sig.expire, 10)
      cachedExpireAt = expireSec ? expireSec * 1000 : now + 3600000
      cachedSignature = sig
      return sig
    })
    .finally(() => {
      inflightPromise = null
    })
  return inflightPromise
}

/** 进入后台后预取签名，首次上传可省一次 RTT */
export function prefetchOssSignature() {
  getCachedOssSignature().catch(() => {})
}
